import Skeleton from '@mui/material/Skeleton';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { Stack } from 'shared/mui/Stack/Stack';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';

type Props = {
  labelWidth?: string;
};

export const GatewaysShowSkeleton: React.FC<Props> = ({ labelWidth = '172px' }) => {
  return (
    <>
      <Stack direction="row" gap={1} sx={{ marginBottom: '24px' }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton height={24} key={i} variant="rounded" width={80} />
        ))}
      </Stack>
      <CardTable tableBodyProps={{ sx: { '& td': { width: labelWidth } } }}>
        {Array.from({ length: 12 }).map((_, i) => (
          <TableRowWrapper key={i} label={<Skeleton />}>
            <Skeleton />
          </TableRowWrapper>
        ))}
      </CardTable>
    </>
  );
};
